<template v-if="dbName && colName" class="text-center">
    <div class="row gx-1 align-items-center">
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="value[1]" :options="options" max-height="150" allow-clear="true"></d-editable-select>
        </div>
        <div class="col-auto">
            <input type="checkbox" v-model="bj" />
            <label for="checkbox" @click="bj=!bj">滤去部分不可获取的技能</label>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> * </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="mulGte[1]"
            @keyup.enter="queryEffects(1, dbName, ['skills','items'], value[1], undefined, {'$lte':mulLte[1]/100,'$gte':mulGte[1]/100}, {'$lte':Number(addLte[1]),'$gte':Number(addGte[1])})" 
            class="form-control">
        </div>
        <div class="col-auto"> ~ </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="mulLte[1]"
            @keyup.enter="queryEffects(1, dbName, ['skills','items'], value[1], undefined, {'$lte':mulLte[1]/100,'$gte':mulGte[1]/100}, {'$lte':Number(addLte[1]),'$gte':Number(addGte[1])})" 
            class="form-control">
        </div>
        <div class="col-auto"> % </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> + </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="addGte[1]"
            @keyup.enter="queryEffects(1, dbName, ['skills','items'], value[1], undefined, {'$lte':mulLte[1]/100,'$gte':mulGte[1]/100}, {'$lte':Number(addLte[1]),'$gte':Number(addGte[1])})" 
            class="form-control">
        </div>
        <div class="col-auto"> ~ </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="addLte[1]"
            @keyup.enter="queryEffects(1, dbName, ['skills','items'], value[1], undefined, {'$lte':mulLte[1]/100,'$gte':mulGte[1]/100}, {'$lte':Number(addLte[1]),'$gte':Number(addGte[1])})" 
            class="form-control">
        </div>
        <div class="col-auto"> % </div>

        <div class="col-auto">
            <button type="submit"
            @click="queryEffects(1, dbName, ['skills','items'], value[1], undefined, {'$lte':mulLte[1]/100,'$gte':mulGte[1]/100}, {'$lte':Number(addLte[1]),'$gte':Number(addGte[1])})" 
            class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible[1] = !visible[1]" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible[1]">
        <json-viewer
            :value="json[1]"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
</template>
  
<script>
import axios from "@/utils/http"
import { CCollapse } from '@coreui/vue'
// import { CCard } from '@coreui/vue'
// import { CCardBody } from '@coreui/vue'
import { CButton } from '@coreui/vue'
import JsonViewer from 'vue-json-viewer'

export default {
    name: 'CommonQuery',
    components: {
        CCollapse, CButton,
        JsonViewer
    },
    data() {
        return {
            bj:false,
            visible: [false,false],
            json:[null,null],
            value:['',''],
            options:[
                {'label': '恢复体力', 'value': 11},
                {'label': '恢复魔力', 'value': 12},
                {'label': '增加特技值', 'value': 13},
            ],
            addGte:[0,-9999,],
            addLte:[0,9999,],
            mulGte:[0,-100],
            mulLte:[0,100],
        }
    },
    props: ['dbName'],
    methods: {
        queryEffects(i, dbName, colList, code, dataId, value1, value2, availableBj){
            availableBj = this.bj  // 偷懒
            this.visible[i] = true
            axios.post('/' + dbName + '/others', { type:'effects', available:availableBj, colList: colList, code:code, dataId:dataId, value1:value1, value2:value2 })
                    .then(response => { this.json[i] = response.data })
        },
    },
    created() {
    }
}
</script>
